//Styles
import { Wrapper } from "./HasUpdateInfo.styles";

type Props = {
  text: string;
};

function HasUpdateInfo({ text }: Props) {
  return <Wrapper>{text}</Wrapper>;
}

export default HasUpdateInfo;
